<template>
	<div>
		<el-row :gutter="40" class="header">
			<el-col :span="12">
				<el-button type="primary" plain size="medium" @click="getData">
					<i class="iconfont icon-refresh"></i>
					刷新
				</el-button>
				<el-button type="success" plain size="medium" @click="exportExcel">
					<i class="iconfont icon-export"></i>
					导出Excel
				</el-button>
			</el-col>
		</el-row>
		<el-card class="box-card" style="margin-bottom: 20px">
			<!-- 加入方式&学习时间段 -->
			<el-row :gutter="40" class="select_row">
				<el-col :span="7">
					<el-row>
						<el-col :span="16" class="floatR">
							<el-input placeholder="请输入内容" size="small" v-model.trim="selectVal.searchValue"
								class="input-with-select" clearable>
							</el-input>
						</el-col>
						<el-col :span="8" v-if="!isInviter">
							<el-select v-model="selectVal.searchKey" placeholder="请选择" size="small" class="floatR"
								style="max-width: 130px">
								<el-option v-for="item in select.searchKey" :key="item.id" :label="item.name"
									:value="item.id">
								</el-option>
							</el-select>
						</el-col>
						<el-col :span="8" class="select_span" v-else>
							<span>医生姓名:</span>
						</el-col>
					</el-row>
				</el-col>
				<el-col :span="7">
					<el-row>
						<el-col :span="16" class="floatR">
							<el-date-picker 
							 size="small"
							 v-model="receiverTime" 
							 type="datetimerange" 
							 range-separator="至"
							 start-placeholder="开始日期"
							 end-placeholder="结束日期"
							 :default-time="['00:00:00', '23:59:59']"
							 value-format="yyyy-MM-dd HH:mm:ss">
							</el-date-picker>
						</el-col>
						<el-col :span="8" class="select_span">
							<span>领取时间:</span>
						</el-col>
					</el-row>
				</el-col>
			</el-row>
            <el-row :gutter="40" class="select_row">
				<el-col :span="7" v-if="!isInviter">
					<el-row>
						<el-col :span="8" class="select_span">
							<span>邀请人:</span>
						</el-col>
						<el-col :span="14">
							<el-input placeholder="请输入" size="small" v-model="selectVal.sharerName" maxlength="20"></el-input>
						</el-col>
					</el-row>
				</el-col>
				<el-col :span="7">
					<el-row>
						<el-col :span="16" class="floatR">
							<el-date-picker
							 size="small"
							 v-model="registerTime" 
							 type="datetimerange" 
							 range-separator="至"
							 start-placeholder="开始日期" 
							 end-placeholder="结束日期" 
							 :default-time="['00:00:00', '23:59:59']"
							 value-format="yyyy-MM-dd HH:mm:ss">
							</el-date-picker>
						</el-col>
						<el-col :span="8" class="select_span">
							<span>注册时间:</span>
						</el-col>
					</el-row>
				</el-col>
			</el-row>
			<!-- 筛选重置 -->
			<el-row :gutter="40" class="select_row">
				<el-col :span="13">
					<el-row>
						<el-col :span="4" class="select_span">&nbsp; </el-col>
						<el-col :span="14">
							<el-button type="warning" plain size="small" @click="resetSelect">重置</el-button>
							<el-button type="primary" plain size="small" @click="screening">筛选</el-button>
						</el-col>
					</el-row>
				</el-col>
			</el-row>
		</el-card>
		<section class="docCourseMember">
			<el-table class="table_list" :data="tableData" border style="width: 100%" highlight-current-row>
				<el-table-column prop="userName" label="姓名" min-width="10%">
					<template slot-scope="scope">
						{{ scope.row.username ? scope.row.username : '-' }}
					</template>
				</el-table-column>
				<el-table-column label="手机号码" min-width="10%">
					<template slot-scope="scope">
						{{ scope.row.phone || '-' }}
					</template>
				</el-table-column>
				<el-table-column label="科室" min-width="10%">
					<template slot-scope="scope">
						{{ scope.row.department || '-' }}
					</template>
				</el-table-column>
				<el-table-column label="职称" min-width="10%">
					<template slot-scope="scope">
						{{ scope.row.title || '-' }}
					</template>
				</el-table-column>
				<el-table-column label="地区" min-width="10%">
					<template slot-scope="scope">
						{{ scope.row.area || '-' }}
					</template>
				</el-table-column>
				<el-table-column label="所属医院" min-width="20%">
					<template slot-scope="scope">
						{{ scope.row.hospital || '-' }}
					</template>
				</el-table-column>
				<el-table-column prop="vipStatus" label="VIP状态" min-width="10%">
					<template slot-scope="scope">
						{{ scope.row.vipState | vipStatus }}
					</template>
				</el-table-column>
				<el-table-column label="注册时间" width="100px">
					<template slot-scope="scope">
						{{ scope.row.regTime | timeFormat }}
					</template>
				</el-table-column>
				<el-table-column label="邀请人" min-width="10%"
                  v-if="!isInviter">
					<template slot-scope="scope">
						{{ scope.row.inviter || '-' }}
					</template>
				</el-table-column>
				<el-table-column label="总学习时长" min-width="10%">
					<template slot-scope="scope">
						{{ scope.row.totalDuration | durationFilter }}
					</template>
				</el-table-column>
				<el-table-column label="最后登录时间" min-width="10%">
					<template slot-scope="scope">
						{{ scope.row.lastLoginTime | timeFormat }}
					</template>
				</el-table-column>
				<el-table-column label="领取时间" min-width="10%">
					<template slot-scope="scope">
						{{ scope.row.getTime | timeFormat }}
					</template>
				</el-table-column>
			</el-table>
			<el-pagination class="pagination" @size-change="handleSizeChange" @current-change="handleCurrentChange"
				:current-page="pageIndex" :page-sizes="[20, 50]" :page-size="pageSize"
				layout="total, sizes, prev, pager, next, jumper" :total="totalCount">
			</el-pagination>
		</section>
	</div>
</template>

<script scoped>
	import requestApi from '@/api/operateManage/hotcourse'
	import searchDocAuto from '@/components/searchDocAuto'
	import exportExcel from '@/utils/exportExcel'
	import dayjs from 'dayjs'
	import {
		mapGetters
	} from 'vuex'
	export default {
		name: 'hotcourse_user',
		components: {
			searchDocAuto
		},
		data() {
			return {
				id: '',
				//用户信息弹窗
				userDialogVisible: false,
				//单个用户信息
				userInfo: {},
				tableData: [],
				receiverTime: [],
				registerTime: [],
				select: {
					searchKey: [{
							id: 'doctorName',
							name: '医生姓名'
						},
						{
							id: 'receivePhone',
							name: '手机号'
						}
					]
				},
				selectVal: {
					searchKey: 'doctorName',
					searchValue: '',
                    sharerName: '',
					doctorName: ''
				},
				courseId: '',
				pageIndex: 1,
				pageSize: 20,
				totalCount: 0,
                paramsProps: {}, // 父组件传递的参数
				/*功能权限*/
				exportShow: false
			}
		},
        props: {
            PAGEKEY: {
                type: String,
                default: () => ''
            }
        },
		computed: {
			...mapGetters('tabs', {
				TABACTIVE: 'tabActive'
			}),
            isInviter() {
                return this.PAGEKEY === 'hotcourse_inviter'
            }
		},
		activated() {
			if (this.id == this.$route.params.id) {
				return
			}
			this.id = this.$route.params.id
            this.paramsProps = this.$route.params.paramsProps
			this.getData()
		},
		methods: {
			resetSelect() {
				this.selectVal = {
					searchKey: 'doctorName',
					searchValue: ''
				}
				this.registerTime = []
				this.receiverTime = []
			},
			getData() {
				let postData = {
					// doctorName: this.selectVal.doctorName || null,
					inviterName: this.selectVal.sharerName || null,
					beginGetTime:  this.receiverTime && this.receiverTime[0] ? this.receiverTime[0] : null,
					endGetTime: this.receiverTime && this.receiverTime[1] ? this.receiverTime[1] : null,
					beginRegTime:  this.registerTime && this.registerTime[0] ? this.registerTime[0] : null,
					endRegTime: this.registerTime && this.registerTime[1] ? this.registerTime[1] : null,
					bcId: this.id,
					inputType: this.isInviter ? 1 : 0
				}
				postData[this.selectVal.searchKey] = this.selectVal.searchValue || null
				let query = {
					page: this.pageIndex,
					size: this.pageSize
				}
				requestApi.userDetails(query, postData).then(res => {
					if (res.Success) {
						this.tableData = res.Data.records
						this.pageIndex = res.Data.current
						this.pageSize = res.Data.size
						this.totalCount = res.Data.total
					} else {
						this.$message.error(res.Msg)
					}
				})
			},
			// 筛选
			screening() {
				this.pageIndex = 1
				this.getData()
			},
			// 导出
			exportExcel() {
				let postData = {
					doctorName: this.selectVal.doctorName || null,
					sharerName: this.selectVal.sharerName || null,
					beginGetTime:  this.receiverTime[0] ? this.receiverTime[0] : null,
					endGetTime: this.receiverTime[1] ? this.receiverTime[1] : null,
					beginRegTime:  this.registerTime[0] ? this.registerTime[0] : null,
					endRegTime: this.registerTime[1] ? this.registerTime[1] : null,
					bcId: this.id,
					inputType: this.isInviter ? 1 : 0
				}
				// postData[this.selectVal.searchKey] = this.selectVal.searchValue || null
				let data = {
					id: this.id,
					data: postData
				}
				exportExcel.download(requestApi.userDetailsExport, data, '用户数据导出')
			},
			handleSizeChange(val) {
				this.pageSize = val
				this.getData()
			},
			handleCurrentChange(val) {
				this.pageIndex = val
				this.getData()
			}
		},
		filters: {
			vipStatus(val) {
				if (val == 0) {
					return '未开通'
				} else if (val == 1) {
					return '生效中'
				} else if (val == 2) {
					return '已过期'
				} else {
					return '-'
				}
			},
			timeFormat(time) {
				if(!time) { return '-' }
				return dayjs(time).format('YYYY-MM-DD HH:mm:ss')
			},
			durationFilter(time) {
				if(!time || time < 60) {
					return (time || 0) + '秒'
				}
				let hourNum = parseInt(time / 60 / 60) || 0
				let minNum = parseInt(time / 60 % 60) || 0
				let secNum = parseInt(time % 60) || 0
				return (hourNum ? hourNum + '小时' : '')
					+ (minNum ? minNum + '分钟' : '')
					+ (secNum ? secNum + '秒' : '')
			},
		}
	}
</script>

<style type="text/less" lang="less" scoped>
	.click_word {
		color: #409eff;
		cursor: pointer;
		text-decoration: underline;
	}
	.pagination {
		float: right;
		margin-top: 10px;
	}
	.box-card {
		padding: 15px 0;
		overflow: initial;
	}
	.table_list {
		margin: 20px 0;
	}
	.header {
		margin-bottom: 15px;
	}
	.select_span {
		text-align: right;
		padding-right: 15px;
		span {
			font-size: 14px;
		}
	}
	.select_row > .el-col {
		position: relative;
		padding-left: 0 !important;
		padding-right: 0 !important;
		margin-left: 20px;
		margin-right: 20px;
		.el-col-7 {
			padding-left: 0;
			padding-right: 0;
		}
	}
	.select_row {
		margin-bottom: 10px;
	}
</style>



// WEBPACK FOOTER //
// src/views/operateManage/hotcourse/components/users.vue